module.exports = __webpack_public_path__ + "static/image-06-c8fac2303628910f25853804bf337c82.jpg";